/** @format */
import React, { FunctionComponent, ReactElement, useState } from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import adescomStyle from '../../../../../assets/jss/adescom/adescomStyle';
import { SimCardServiceItem } from '../../../../../interfaces/collections/SimCardServiceInterface';
import I18n from '../../../../../components/Translate/I18n';
import GridItem from '../../../../../components/Grid/GridItem';
import GridContainer from '../../../../../components/Grid/GridContainer';
import { OplBmeUsage } from './OplBmeUsage';
import { DateHelperTs } from '../../../../../helpers/DateHelperTs';

const useStyle = makeStyles(adescomStyle);

type BmeParamsType = {
    simCardService: SimCardServiceItem;
};

interface ServiceComponentParam {
    name: string;
    value: string | number | null;
}

export const McBmeParams: FunctionComponent<BmeParamsType> = ({ simCardService }): ReactElement | null => {
    const classes = useStyle();
    const tableCellRoot = { root: classes.tableCellRoot };
    const [disableRenew, setDisableRenew] = useState(false);

    const f = 3;
    const s = 9;

    return (
        <TableRow>
            <TableCell classes={tableCellRoot} padding="none" align="right" />
            <TableCell classes={tableCellRoot} padding="none" align="left" colSpan={3}>
                <OplBmeUsage params={simCardService.servicesParams} displayParamName={true} />
                {simCardService.expireOn && (
                    <>
                        <GridContainer key={'componentParamsExpireOn' + simCardService.id}>
                            <GridItem xs={f}>
                                <I18n trans="simcard:f.param_name" />
                            </GridItem>
                            <GridItem xs={f}>
                                <I18n trans="simcard:f.expiredOn_singleShot" />
                            </GridItem>
                            <GridItem xs={f}>
                                <I18n trans="simcard:f.param_value" />
                            </GridItem>
                            <GridItem xs={f}>
                                {!disableRenew && simCardService.cycleSkip === -1 && DateHelperTs.format(simCardService.expireOn, 'YYYY-MM-DD')}
                                {((disableRenew && !simCardService.singleShot) || (simCardService.cycleSkip === 1 && !simCardService.singleShot)) && (
                                    <span style={{ textDecoration: 'line-through' }}>
                                        {DateHelperTs.format(simCardService.expireOn, 'YYYY-MM-DD')}
                                    </span>
                                )}
                            </GridItem>
                        </GridContainer>
                    </>
                )}
            </TableCell>
        </TableRow>
    );
};
